module.exports = __webpack_public_path__ + "static/media/main idea.8bbab569.mp3";